import { http } from '@pendo/http';

// source config
export function getAllSourceConfigs () {
    return http
        .get('/api/s/_SID_/vocSourceConfig')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getSourceConfig ({ domain, objectName, objectId }) {
    return http
        .get(`/api/s/_SID_/vocSourceConfig/${domain}/${objectName}/${objectId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateSourceConfig (domain, objectName, objectId, updateSourceConfigBinding) {
    return http
        .put(`/api/s/_SID_/vocSourceConfig/${domain}/${objectName}/${objectId}`, updateSourceConfigBinding)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function doHistoricSendToSalesforce (domain, objectName, objectId) {
    return http
        .post(`/api/s/_SID_/vocSourceConfig/${domain}/${objectName}/${objectId}/historicSendToSFDC`, {})
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function createSourceConfig (domain, objectName, objectId, createSourceConfigBinding) {
    return http
        .post(`/api/s/_SID_/vocSourceConfig/${domain}/${objectName}/${objectId}`, createSourceConfigBinding)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function deleteSourceConfig ({ configId }) {
    return http.delete(`/api/s/_SID_/vocSourceConfig/${configId}`).catch((err) => {
        throw err;
    });
}

// field mapping
export function getGuideFieldMapping ({ guideId }) {
    return http
        .get(`/api/s/_SID_/vocFieldMapping/Internal/Guide/${guideId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateGuideFieldMapping ({ guideId, vocFieldMappingPayload }) {
    return http
        .put(
            `/api/s/_SID_/vocFieldMapping/Internal/Guide/${guideId}`,
            {
                vocFieldMappings: vocFieldMappingPayload,
            },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getSavedViewForImport ({ importType, importId }) {
    return http
        .get(`/api/s/_SID_/vocItem/import/${importType}/${importId}/savedView`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
